<template>
    <a
        v-bastards
        ref="link"
        :href="url || ''"
        :target="target"
        class="button-primary btn btn-c--primary text-color-contrast fs-17 text-upper"
        @click="onClick"
    >
        {{ label }}
    </a>
</template>

<script>
import IsIE from '@/plugins/ie'

export default {
    props: {
        label: {
            type: String,
            default: ''
        },
        url: {
            type: [String, Blob],
            default: ''
        },
        target: {
            type: String,
            default: '_self'
        },
        isDownload: {
            type: Boolean,
            default: false
        },
        downloadLabel: {
            type: String,
            default: 'pobrane',
        },
        blob: {
            type: Blob,
            default: null
        }
    },

    mounted() {
        if (this.isDownload) {
            this.$refs.link.setAttribute('download', this.downloadLabel)
        }
    },

    methods: {
        onClick() {
            if (this.isDownload && (IsIE.isIE() || IsIE.isIE11())) {
                window.navigator.msSaveBlob(this.blob, this.downloadLabel)
            }
        }
    }
}
</script>

<style lang="scss">
.button-primary {
    padding: 23px 54px;
}
</style>
